import React, { useEffect, useState } from "react";
import SplashScreen from "./SplashScreen";

interface WithSplashOnMediaLoadProps {
  sources: string | string[];
  children: React.ReactNode;

  delay?: number;

  timeout?: number;


  postDelay?: number;
}


const WithSplashOnMediaLoad: React.FC<WithSplashOnMediaLoadProps> = ({
  sources,
  children,
  delay = 700,
  timeout = 7000,
  postDelay = 800,
}) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const list = Array.isArray(sources) ? sources : [sources];


    if (list.length === 0) {
      setLoaded(true);
      return;
    }

    let isCancelled = false;
    let loadedCount = 0;

    const finish = () => {
 
      window.setTimeout(() => {
 
        window.setTimeout(() => {
          if (!isCancelled) {
            setLoaded(true);
          }
        }, postDelay);
      }, delay);
    };

    const handleOneLoaded = () => {
      if (isCancelled) return;
      loadedCount += 1;
      if (loadedCount >= list.length) {
        finish();
      }
    };

    const fallbackTimer = window.setTimeout(() => {
      if (!isCancelled) {
        setLoaded(true);
      }
    }, timeout);

    list.forEach((src) => {

      if (/\.(mp4|webm)$/i.test(src)) {
        const video = document.createElement("video");
        let done = false;

        const markDone = () => {
          if (done) return;
          done = true;
          handleOneLoaded();
          cleanup();
        };

        const cleanup = () => {
          video.removeEventListener("loadeddata", markDone);
          video.removeEventListener("canplay", markDone);
          video.removeEventListener("canplaythrough", markDone);
          video.removeEventListener("error", markDone);
        };

        video.src = src;
        video.preload = "auto";
        video.muted = true;
        video.playsInline = true;

        video.addEventListener("loadeddata", markDone);
        video.addEventListener("canplay", markDone);
        video.addEventListener("canplaythrough", markDone);
        video.addEventListener("error", markDone);

     
        video.load();
      } else {
      
        const img = new Image();
        let done = false;

        const markDone = () => {
          if (done) return;
          done = true;
          handleOneLoaded();
          cleanup();
        };

        const cleanup = () => {
          img.onload = null;
          img.onerror = null;
        };

        img.onload = markDone;
        img.onerror = markDone;
        img.src = src;
      }
    });

    return () => {
      isCancelled = true;
      window.clearTimeout(fallbackTimer);
    };
  }, [sources, delay, timeout, postDelay]);

  if (!loaded) return <SplashScreen />;

  return <>{children}</>;
};

export default WithSplashOnMediaLoad;
